import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, clearToken } from '@/utils/tokenManager';
import logger from '../utils/logger';

const AdminProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const checkAdminAuth = async () => {
    try {
      const token = getToken();
      
      const response = await fetch(`${API_URL}/api/admin/me`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {},
      });

      if (response.ok) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        clearToken();
      }
    } catch (error) {
      logger.error('Auth check failed:', error);
      setIsAuthenticated(false);
      clearToken();
    }
  };

  useEffect(() => {
    checkAdminAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-linear-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render children if authenticated
  return children;
};

export default AdminProtectedRoute;